// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { Context_abstract } from './../abstract/SagaBase/Context_abstract';
export class Context extends Context_abstract {}
